import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import './homeCard.css';

const HomeCard = ({ title, photo, className, onClick }) => {
    return (
        <Card 
          onClick={onClick}
          className='card'>
            <CardContent className='cardtitle'>
                <div className='cardtitletext'>{title}</div>
            </CardContent>
            <div>
                <img src={photo} className={className} alt="description"/>
            </div>
        </Card>
    );
}

export default HomeCard;



// WEBPACK FOOTER //
// ./src/components/homecard/HomeCard.js